import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider} from '@tanstack/react-query';
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "./styles/styles.scss";
import 'sweetalert/dist/sweetalert.css';

import "./i18n";

import App from "./App";

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
